import React from "react";
import { pastUploadTableHeaders } from "../../constants/TableConstants";
import PastUploadsTable from "../../components/PastInventoryUploadsTable/PastUploadsTable";

const PastUploads = ({
  ongoingUploadStatus,
  pastUploads = [],
  handleDownloadFile,
  handleRetry,
}) => {
  return (
    <>
      <PastUploadsTable
        ongoingUploadStatus={ongoingUploadStatus}
        pastUploads={pastUploads}
        headers={pastUploadTableHeaders}
        handleRetry={handleRetry}
        handleDownload={handleDownloadFile}
      />
    </>
  );
};

export default PastUploads;
